<script lang="ts" setup>
import { computed, useSlots } from 'vue'
const props = defineProps<{
  content?: string
  class?: string
  sensitive?: boolean
  oneLine?: boolean
}>()
const slots = useSlots()
const hasSlot = () => {
  return !!slots['default']
}
const sensitiveClass = computed(() => {
  return props.sensitive ? 'sentry-mask' : ''
})
</script>
<template>
  <slot>
    <!-- class="whitespace-nowrap overflow-hidden text-ellipsis maw-w-full"
    :class="sensitiveClass" -->
    <span>
      {{ props.content }}
    </span>
  </slot>
  <!-- <TooltipProvider v-if="props.oneLine">
    <Tooltip>
      <TooltipTrigger as-child>
        <span
          :class="
            cn(
              // 'whitespace-nowrap overflow-hidden text-ellipsis w-full',
              props.class,
              sensitiveClass
            )
          "
        >
          <span v-if="!hasSlot()">{{ props.content }}</span>
          <slot />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p :class="cn('text-sm', sensitiveClass)">{{ props.content }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
  <span v-else>
    <span v-if="!hasSlot()">{{ props.content }}</span>
    <slot />
  </span> -->
</template>
